import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Link2, MousePointerClick, FileText, Inbox, Users as UsersIcon, HelpCircle, Megaphone, Image } from "lucide-react";
import api from "@/lib/api";
import { AdminHeader, Panel } from "@/components/admin/ui";

export default function Dashboard() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/dashboard").then((r) => setD(r.data)).catch(() => {}); }, []);

  const cards = d ? [
    { label: "External Links", value: d.links, sub: `${d.total_clicks} total clicks`, Icon: Link2, to: "/admin/links" },
    { label: "Link Clicks", value: d.total_clicks, sub: "tracked", Icon: MousePointerClick, to: "/admin/links" },
    { label: "News Articles", value: d.news, sub: "published & drafts", Icon: FileText, to: "/admin/news" },
    { label: "Education Guides", value: d.education, sub: "learning content", Icon: FileText, to: "/admin/education" },
    { label: "FAQ Items", value: d.faq, sub: "questions", Icon: HelpCircle, to: "/admin/faq" },
    { label: "Promotions", value: d.promotions, sub: "campaigns", Icon: Megaphone, to: "/admin/promotions" },
    { label: "Media Assets", value: d.media, sub: "in library", Icon: Image, to: "/admin/media" },
    { label: "Contact Inbox", value: d.contacts, sub: `${d.unread_contacts} unread`, Icon: Inbox, to: "/admin/contacts" },
  ] : [];

  return (
    <div>
      <AdminHeader title="Dashboard" subtitle="Overview of your website content and activity." />
      {!d ? <p className="text-slate-500">Loading…</p> : (
        <>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
            {cards.map((c) => (
              <Link to={c.to} key={c.label} className="cb-card-dark p-5 block" data-testid={`stat-card-${c.label.toLowerCase().replace(/\s+/g, "-")}`}>
                <div className="flex items-center justify-between mb-3">
                  <c.Icon className="gold-text" size={20} />
                </div>
                <p className="font-serif text-3xl text-white">{c.value}</p>
                <p className="text-slate-400 text-sm mt-1">{c.label}</p>
                <p className="text-slate-500 text-xs mt-0.5">{c.sub}</p>
              </Link>
            ))}
          </div>

          <Panel className="p-6">
            <h2 className="font-serif text-xl text-white mb-4">Recent Activity</h2>
            {d.recent_audit.length === 0 ? <p className="text-slate-500 text-sm">No activity yet.</p> : (
              <div className="space-y-3">
                {d.recent_audit.map((a) => (
                  <div key={a.id} className="flex items-center justify-between py-2 border-b border-[#203E70] last:border-0" data-testid={`activity-${a.id}`}>
                    <div className="text-sm">
                      <span className="text-white">{a.user_name || a.user_email}</span>
                      <span className="text-slate-400"> {a.action} </span>
                      <span className="gold-text">{a.resource}</span>
                      {a.detail && <span className="text-slate-500"> — {a.detail}</span>}
                    </div>
                    <span className="text-xs text-slate-600 font-mono shrink-0 ml-4">{new Date(a.created_at).toLocaleString()}</span>
                  </div>
                ))}
              </div>
            )}
          </Panel>
        </>
      )}
    </div>
  );
}
